export enum TreeEntities {
    Company,
    Property,
    User,
    CancelledCompany
}

export enum RelationshipType {
    Unknown = 0,
    Roommate = 1,
    Spouse = 2,
    Minor = 3,
    OtherGuest = 4
}

export enum Roles {
    None = 'None',
    NoneId = '0',
    // Property-level roles
    PropertyUser = 'PropertyUser',
    PropertyUserId = '1',
    PropertyDashboardUser = 'PropertyDashboardUser',
    PropertyDashboardUserId = '2',
    PropertyDashboardAdmin = 'PropertyDashboardAdmin',
    PropertyDashboardAdminId = '4',
    PropertyAnalyticsUser = 'PropertyAnalyticsUser',
    PropertyAnalyticsUserId = '8',
    PropertyAnalyticsAdmin = 'PropertyAnalyticsAdmin',
    PropertyAnalyticsAdminId = '16',
    PropertyManageUser = 'PropertyManageUser',
    PropertyManageUserId = '32',
    PropertyManageAdmin = 'PropertyManageAdmin',
    PropertyManageAdminId = '64',
    PropertyAdmin = 'PropertyAdmin',
    PropertyAdminId = '128',
    // Company-level roles
    CompanyDashboardUser = 'CompanyDashboardUser',
    CompanyDashboardUserId = '256',
    CompanyDashboardAdmin = 'CompanyDashboardAdmin',
    CompanyDashboardAdminId = '512',
    CompanyAnalyticsUser = 'CompanyAnalyticsUser',
    CompanyAnalyticsUserId = '1024',
    CompanyAnalyticsAdmin = 'CompanyAnalyticsAdmin',
    CompanyAnalyticsAdminId = '2048',
    CompanyManageUser = 'CompanyManageUser',
    CompanyManageUserId = '4096',
    CompanyManageAdmin = 'CompanyManageAdmin',
    CompanyManageAdminId = '8192',
    CompanyAdmin = 'CompanyAdmin',
    CompanyAdminId = '16384',
    // System-level roles
    SystemDashboardUser = 'SystemDashboardUser',
    SystemDashboardUserId = '32768',
    SystemDashboardAdmin = 'SystemDashboardAdmin',
    SystemDashboardAdminId = '65536',
    SystemAnalyticsUser = 'SystemAnalyticsUser',
    SystemAnalyticsUserId = '131072',
    SystemAnalyticsAdmin = 'SystemAnalyticsAdmin',
    SystemAnalyticsAdminId = '262144',
    SystemManageUser = 'SystemManageUser',
    SystemManageUserId = '524288',
    SystemManageAdmin = 'SystemManageAdmin',
    SystemManageAdminId = '1048576',
    SystemAdmin = 'SystemAdmin',
    SystemAdminId = '2097152',
    // Special roles
    CustomerSupportRepresentative = 'CustomerSupportRepresentative',
    CustomerSupportRepresentativeId = '4194304',
    StratisUser = 'StratisUser',
    StratisUserId = '8388608',
    OnCellUser = 'OnCellUser',
    OnCellUserId = '16777216',
    Tour24ApiUser = 'Tour24ApiUser',
    Tour24ApiUserId = '33554432',
    ProspectUser = 'ProspectUser',
    ProspectUserId = '67108864',
    NoAccessUser = 'NoAccessUser',
    NoAccessUserId = '134217728'
}

export const AdminRoles = [
    Roles.SystemAdmin,
    Roles.CompanyAdmin,
    Roles.PropertyAdmin,
    Roles.PropertyUser,
    Roles.CustomerSupportRepresentative
];

export const Permissions = [
    Roles.CompanyAnalyticsUser,
    Roles.CompanyManageAdmin,
    Roles.CompanyManageUser,
    Roles.CompanyDashboardAdmin,
    Roles.CompanyDashboardUser,
    Roles.PropertyAnalyticsUser,
    Roles.PropertyManageAdmin,
    Roles.PropertyManageUser,
    Roles.PropertyDashboardAdmin,
    Roles.PropertyDashboardUser,
    Roles.SystemAnalyticsUser,
    Roles.SystemManageAdmin,
    Roles.SystemManageUser,
    Roles.SystemDashboardAdmin,
    Roles.SystemDashboardUser
];

export enum ProspectGridColumns {
    Name = 'name',
    TourDate = 'tourDate',
    TimeSlot = 'timeSlot',
    Status = 'status',
    MoveInDate = 'moveInDate',
    Email = 'email',
    Partner = 'partnerName',
    Phone = 'phone',
    DateCreated = 'dateCreated',
    TourStart = 'tourStart',
    TourCreationDate = 'tourCreationDate',
    VirtualTourStatus = 'virtualStatus'
}

export enum ProspectsGridColumns {
    Name = 'name',
    Email = 'email',
    Phone = 'phone',
    InitialDate = 'initialDate',
    LastTourDate = 'lastTourDate',
    LastTourPropertyName = 'lastTourDatePropertyName',
    Status = 'tourStatus',
    ApplicationStatus = "applicationStatus",
    TotalPropertiesVisited = "totalPropertiesVisited"
}

export enum TourGridColumns {
    Name = 'name',
    Phone = 'phone',
    Email = 'email',
    PropertyName = 'propertyName',
    Partner = 'partnerName',
    TourCreationDate = 'tourCreationDate',
    TourDate = 'tourStartDate',
    TourTime = 'tourStartTime',
    TourEndTime = 'tourEndTime',
    Status = 'tourStatus'
}

export enum ColorConstants {
    PrimaryColor = '#27bbf9',
}


export enum OnfidoIdVerificationStatuses {
    FailedBothChecks = 'FailedBothChecks',
    CheckPassed = 'CheckPassed',
    FailedFirstCheckOnSecond = 'FailedFirstCheckOnSecond',
    OnFirstCheck = 'OnFirstCheck',
    WaitingForResult = 'WaitingForResult',
    ErrorOccurred = 'ErrorOccurred',
    ExpirationCaptureFailed = 'ExpirationCaptureFailed'
}

export enum ReportFrequency {
    None = 0,
    Monthly = 1,
    Weekly = 2
}

export enum TourStatuses {
    Scheduled = 'Scheduled',
    Cancelled = 'Cancelled',
    Complete = 'Complete',
    Reminded = 'Reminded',
    NoShow = 'No show',
    Applied = 'Applied',
    Finished = 'Finished'
}

export enum TourSelectionOptions {
    Applied = 'Applied',
    All = 'All',
    Excluded = 'Excluded'
}

export enum VirtualToursEnabled {
    Disabled = 0,
    EnabledAsOption = 1,
    EnabledAsOnlyOption = 2
}

export enum PreferredTourFormat {
    SelfGuided = 0,
    AgentGuided = 1,
    Virtual = 2
}

export enum TourType {
    Standard = 0,
    Appless = 1,
    AgentGuided = 2
}

export enum CollectionType {
    Tour = 0,
    List = 1
}

export enum StartDay {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

export enum VirtualTourStatus {
    None = 0,
    Registered = 1,
    Reminded = 2,
    Complete = 3
}

export enum SourceType {
    None = 0,
    Snippet = 1,
    Knock = 2,
    BetterBot = 3,
    Hyly = 4,
    Funnel = 5,
}



// WEBPACK FOOTER //
// ./src/utilities/Enums.ts